export interface ClinicAccess {
  type: 'all' | 'subset';
  clinics?: Array<string | { _id: string }>;
}

export interface ClinicScopeUser {
  role?: string;
  clinicAccess?: ClinicAccess;
}

const toClinicId = (clinic: string | { _id: string }): string =>
  typeof clinic === 'object' ? clinic._id : clinic;

/** Admin bypasses subset restriction (matches backend clinicScope middleware). */
export function canViewAllClinics(user?: ClinicScopeUser | null): boolean {
  if (!user) return true;
  if (user.role === 'admin') return true;
  return user.clinicAccess?.type !== 'subset';
}

/** Allowed clinic IDs for subset users; `null` means no restriction (all org clinics). */
export function getAllowedClinicIds(user?: ClinicScopeUser | null): string[] | null {
  if (!user || canViewAllClinics(user)) return null;
  return (user.clinicAccess?.clinics || []).map(toClinicId).filter(Boolean);
}

export function resolveClinicScopeForUser(
  user: ClinicScopeUser | null | undefined,
  storedScope: string | null
): string {
  const scope = storedScope || 'all';

  if (canViewAllClinics(user)) {
    return scope;
  }

  const allowed = getAllowedClinicIds(user);
  if (!allowed || allowed.length === 0) {
    return scope;
  }

  if (scope !== 'all' && allowed.includes(scope)) {
    return scope;
  }

  return allowed[0];
}
